import type { FaireProductEntity } from "../../entity_types/product";

export const p_8b2586npqq: FaireProductEntity = {
  token: "p_8b2586npqq",
  type: "product",
  name: "All-Natural Organic Bath Bombs - Relaxing 6 Set",
  brandName: "Relaxcation",
  imageUrl:
    "https://cdn.faire.com/fastly/4637b636b0f6edf92fe46d5cba16f828991ef68218e1157fdd8c93a2ed1232d4.jpeg",
  priceDollars: 15,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/16940ce8b825dfb7e711a584fb182bbde6637d68d62a29e5451a6c1deea69edc.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
